// extracted by mini-css-extract-plugin
module.exports = {"cursor":"OwnSocialCursor_cursor__2Q5_H","nounHeadImage":"OwnSocialCursor_nounHeadImage__2-qA7"};